export default __webpack_public_path__ + "static/media/Nemo-goa-guide.624c23c9.md";